module.exports = __webpack_public_path__ + "static/media/user2.6698f40f.png";